import { utils } from '@didi/webx-js-core';
import { canIUse } from '../canIUse';
import { isLogin } from '../login';
import { locate } from '../locate';
import { query, hashQuery } from '../query';
import { storage } from '../storage';
import { is, xenv } from '../xenv';
import { xenvActionFactory } from '../xenv';
import { driverGetSystemInfo, kfdriverGetSystemInfo, kfpassengerGetSystemInfo, passengerGetSystemInfo, esappGetSystemInfo, hitchappGetSystemInfo, hydriverGetSystemInfo } from '../platform/xenv';
const xenvUnionByGetSystemInfoList = ['driver', 'kfdriver', 'kfpassenger', 'passenger'];
const xenvGetSystemInfoConfig = {
    'driver': driverGetSystemInfo,
    'kfdriver': kfdriverGetSystemInfo,
    'kfpassenger': kfpassengerGetSystemInfo,
    'passenger': passengerGetSystemInfo,
    'esapp': esappGetSystemInfo,
    'hitchapp': hitchappGetSystemInfo,
    'hydriver': hydriverGetSystemInfo
};
const _getSystemInfo = () => {
    const fn = xenvActionFactory('getSystemInfo', xenvGetSystemInfoConfig);
    return fn();
};
const fromChannelMap = {
    alimp: '3',
    alipay: '3',
    bdmp: '8',
    cowxmp: '2',
    driver: '6',
    drwxmp: '2',
    gjwxmp: '2',
    h5: '8',
    kfalimp: '3',
    kfdriver: '5',
    kfdwxmp: '2',
    kfpassenger: '5',
    kfwxmp: '2',
    mqq: '4',
    passenger: '1',
    qqmp: '4',
    thwxmp: '2',
    weixin: '2',
    wxmp: '2',
    dymp: '10',
    yxwxmp: '2',
    sfcwxmp: '2',
    sfcalimp: '3',
    hyalimp: '3',
    cralimp: '3',
    eshwxmp: '2'
};
const appIdMap = {
    alimp: '30002',
    alipay: '130005',
    bdmp: '30004',
    cowxmp: '31000',
    driver: '20000',
    drwxmp: '30004',
    gjwxmp: '30004',
    h5: '30004',
    kfalimp: '130006',
    kfdriver: '130001',
    kfdwxmp: '130006',
    kfpassenger: '130000',
    kfwxmp: '130006',
    mqq: '30004',
    passenger: '10000',
    qqmp: '30001',
    thwxmp: '30004',
    weixin: '130002',
    wxmp: '30012',
    dymp: '121342',
    yxwxmp: '30004',
    gaswxmp: '121061',
    sfcwxmp: '120221',
    sfcalimp: '120233',
    cralimp: '121377',
    eshwxmp: '30004',
    hyalimp: '30004'
};
const _envInfo = {
    // 业务信息
    dchn: undefined,
    // 登录信息
    newTicket: undefined,
    // 定位信息
    latitude: undefined,
    longitude: undefined,
    cityId: undefined,
    // UA
    userAgent: undefined,
    // 设备信息
    appVersion: undefined,
    wifi: undefined,
    model: undefined,
    ddfp: undefined,
    // 其他
    // 枚举值，根据xenv返回指定值
    fromChannel: undefined,
    newAppid: undefined,
    // openId
    openId: undefined,
    openIdType: undefined,
    // 来源页
    fromPage: undefined,
    // 埋点传参，基于前端埋点数据进行基础机刷判断
    isHitButton: false,
    isOpenWeb: true,
    timeCost: undefined,
};
const _startTimeStamp = (Date && Date.now()) || 0;
let _queryObject;
const _getUserInfoAsync = () => {
    return new Promise((resolve, reject) => {
        if (storage.userInfo.token) {
            _envInfo.newTicket = storage.userInfo.token;
            return resolve({});
        }
        if (canIUse('isLogin')) {
            isLogin({ useQuick: true }).then(res => {
                _envInfo.newTicket = (res && res.token) || undefined;
                resolve({});
            }).catch(() => reject());
        }
        else {
            reject();
        }
    });
};
const _getLocationInfoAsync = (force = true) => {
    return new Promise((resolve, reject) => {
        if ((storage.locationInfo.lat && storage.locationInfo.lng) || storage.locationInfo.cityId) { // storage中已缓存经纬度 则从storage中取
            _envInfo.latitude = String(storage.locationInfo.lat || '') || undefined;
            _envInfo.longitude = String(storage.locationInfo.lng || '') || undefined;
            _envInfo.cityId = String(storage.locationInfo.cityId || '') || undefined;
            resolve({});
        }
        else if (force && canIUse('locate')) { // 缓存中不存在定位信息 主动获取
            locate().then(res => {
                _envInfo.latitude = String(res.lat || '') || undefined;
                _envInfo.longitude = String(res.lng || '') || undefined;
                _envInfo.cityId = String(res.cityId || '') || undefined;
                resolve({});
            }).catch(() => reject());
        }
        else {
            reject();
        }
    });
};
const _getSystemInfoAsync = () => {
    return new Promise((resolve, reject) => {
        if (xenvUnionByGetSystemInfoList.includes(xenv())) {
            _getSystemInfo().then(res => {
                const { ddfp, appversion, netstat, model } = res;
                _envInfo.ddfp = String(ddfp || '') || undefined;
                _envInfo.appVersion = String(appversion || '') || undefined;
                _envInfo.wifi = (netstat && netstat.toLowerCase() === 'wifi' ? '1' : '2') || undefined;
                _envInfo.model = String(model || '') || undefined;
                resolve({});
            }).catch(() => reject());
        }
        else {
            reject();
        }
    });
};
const _getChannelInfo = () => {
    _envInfo.fromChannel = fromChannelMap[xenv()] || undefined;
    _envInfo.newAppid = appIdMap[xenv()] || undefined;
};
const _getMiniprogramInfo = () => {
    if (is('miniprogram')) { // 小程序webview环境
        _queryObject = Object.assign({}, query(), hashQuery());
        _envInfo.openId = _queryObject.openid;
        if (is('weixin'))
            _envInfo.openIdType = '1';
        if (is('alipay'))
            _envInfo.openIdType = '2';
        if (is('mqq'))
            _envInfo.openIdType = '3';
    }
};
const _calculationDuration = (startTimeStamp = 0) => {
    if (Number(startTimeStamp) === 0)
        return;
    try {
        const duration = Date.now() - startTimeStamp;
        if (duration >= 0)
            _envInfo.timeCost = duration;
    }
    catch (e) {
        console.log('获取时间戳失败', e);
    }
};
const _getUserAgent = () => {
    try {
        _envInfo.userAgent = window.navigator.userAgent;
    }
    catch (e) {
        console.error(e);
        _envInfo.userAgent = undefined;
    }
};
const _getDchn = () => {
    try {
        _queryObject = Object.assign({}, query(), hashQuery());
        _envInfo.dchn = _queryObject.dchn;
    }
    catch (e) {
        console.error(e);
    }
};
/* 异步获取环境/风控信息 */
export const getEnvInfo = (config = { forceLocate: true, startTimeStamp: 0 }) => {
    const { forceLocate, startTimeStamp } = config;
    _getUserAgent();
    _getDchn();
    _getChannelInfo();
    _getMiniprogramInfo();
    _calculationDuration(startTimeStamp || _startTimeStamp);
    return new Promise((resolve, reject) => {
        Promise.allSettled([_getUserInfoAsync(), _getLocationInfoAsync(forceLocate), _getSystemInfoAsync()]).then(() => {
            utils.cleanEmptyKey(_envInfo); // 清除风控参数对象中的undefined和null
            storage.riskParams = _envInfo;
            resolve(_envInfo);
        }).catch(() => {
            utils.cleanEmptyKey(_envInfo); // 清除风控参数对象中的undefined和null
            storage.riskParams = _envInfo;
            reject();
        });
    });
};
